import React, { useState, useEffect } from 'react';
import {
    FaPlus,
    FaChevronDown,
    FaChevronUp,
    FaUsers,
    FaBroadcastTower,
    FaTelegramPlane
} from 'react-icons/fa';
import apiUtils from 'utils/apiutils';
import { Check, X } from "lucide-react";
import { Switch } from 'antd';

// Modern Modal Component
const Modal = ({ modalType, secretKey, setSecretKey, onClose, onSubmit }) => (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
        <div className="bg-card border border-border rounded-3xl w-full max-w-md shadow-card animate-in slide-in-from-bottom-4 duration-300">
            <div className="p-6">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 rounded-xl bg-gradient-button text-white">
                        {modalType === 'group' ? <FaUsers className="w-5 h-5" /> : <FaBroadcastTower className="w-5 h-5" />}
                    </div>
                    <h2 className="text-xl font-semibold text-foreground">
                        Add Secret Key for {modalType === 'group' ? 'Group ID' : 'Channel ID'}
                    </h2>
                </div>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-muted-foreground mb-2">
                            Secret Key
                        </label>
                        <input
                            type="text"
                            value={secretKey}
                            onChange={(e) => setSecretKey(e.target.value)}
                            placeholder="Enter Secret Key"
                            className="w-full p-3 bg-input border border-border bg-logiculustheme-colorDark text-white rounded-xl  placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-200"
                        />
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-3 bg-logiculustheme-colorSecondaryDark text-secondary-foreground rounded-xl font-medium transition-all duration-200 hover:bg-secondary/80"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onSubmit}
                            className="flex-1 px-4 py-3 bg-logiculustheme-neonBlue text-white rounded-xl font-medium transition-all duration-200 hover:scale-105 transform shadow-glow"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);


const Table = ({ data, columns }) => {
    const [tableData, setTableData] = useState(data || []);

    // 🔥 Toggle handler for nested Notifications
    const handleNestedToggle = async (rowIndex, key, valueKey, currentValue) => {
        const newStatus = currentValue;
        console.log(newStatus, "fd");


        // Update UI instantly
        const updated = [...tableData];
        updated[rowIndex][key][valueKey] = newStatus;
        setTableData(updated);

        // API CALL
        try {
            await apiUtils.post(
                "/telegram/set_status",
                { status: newStatus },
                { showToast: true }
            );
            viewdetails()

        } catch (err) {

            // rollback if API fails
            updated[rowIndex][key][valueKey] = currentValue;
            setTableData([...updated]);
        }
    };

    // Render function
    const renderValue = (value, rowIndex, parentKey = null) => {
        // Handle only the Notifications object
        if (parentKey === "Notifications") {

            // Only pick Telegram
            const telegramStatus = value?.Telegram;

            return (
                <div className="flex items-center gap-2">
                    <span className="font-medium">Telegram:</span>

                    <Switch
                        checked={telegramStatus}
                        onChange={(checked) =>
                            handleNestedToggle(rowIndex, parentKey, "Telegram", checked)
                        }
                        style={{
                            backgroundColor: telegramStatus ? "#22c55e" : "#a3a3a3",
                        }}
                    />
                </div>
            );
        }

        // Handle normal booleans
        if (typeof value === "boolean") {
            return value ? (
                <Check className="w-5 h-5 text-green-500" />
            ) : (
                <X className="w-5 h-5 text-red-500" />
            );
        }

        // Default object handling (for future fields)
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }

        return value ?? "-";
    };


    return (
        <div className="overflow-hidden border border-border bg-card">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-white/5 backdrop-blur-sm border border-white/10">
                        <tr>
                            {columns.map((col, index) => (
                                <th
                                    key={index}
                                    className="px-6 py-4 text-left text-sm font-semibold text-muted-foreground uppercase tracking-wider"
                                >
                                    {col.replace(/_/g, " ")}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-border">
                        {tableData?.map((item, rowIndex) => (
                            <tr key={rowIndex} className="hover:bg-muted/30 transition-colors duration-200">
                                {columns.map((col, colIndex) => (
                                    <td key={colIndex} className="px-6 py-4 text-sm text-foreground">
                                        {col === "Notifications"
                                            ? renderValue(item[col], rowIndex, "Notifications")
                                            : renderValue(item[col], rowIndex)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};




const TelegramAlerts = () => {
    // State management
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [userdetails, setuserdetails] = useState([]);
console.log(userdetails,"userdetails");


    // Toggle accordion
    const toggleAccordion = (section) => {
        setActiveAccordion(activeAccordion === section ? null : section);
        setSecretKey('');
    };

    const generatetelegramlink = async () => {
        try {
            const response = await apiUtils.post('/telegram/generate_telegram_link_chatid', {}, { showToast: true });
            if (response && response?.Link) {
                const fullLink = response.Link.startsWith("http") ? response.Link : `https://${response.Link}`;
                window.open(fullLink, "_blank");
            }
        } catch (err) {
        }
    };

    const viewdetails = async () => {
        try {
            const response = await apiUtils.post('/telegram/view_telegram_user_details', {}, { showToast: false });

            if (response) {
                setuserdetails([response.Success]);
            }
        } catch (err) {

        }
    };

    useEffect(() => {
        viewdetails();
    }, []);

    const groupSteps = [
        {
            step: 1,
            title: 'Add Cryptologistics Bot',
            description: 'Add @CryptologisticsBot to your Telegram group with necessary permissions.',
        },
        // {
        //     step: 2,
        //     title: 'Make Bot Admin',
        //     description: 'Ensure the bot is made an admin with permission to read messages.',
        // },
        {
            step: 2,
            title: 'Click Add Secret Key',
            description: 'Use the button below to generate the secret key and save the group ID.',
        }
    ];

    const channelSteps = [
        {
            step: 1,
            title: 'Add Cryptologistics Bot',
            description: 'Add @CryptologisticsBot to your Telegram channel.',
        },
        {
            step: 2,
            title: 'Make Bot Admin',
            description: 'Make the bot an admin so it can post alerts to your channel.',
        },
        {
            step: 3,
            title: 'Send  "hi" in the Channel',
            description: 'Type and send the message **hi** in your channel to verify the bot connection.',
        },
        {
            step: 4,
            title: 'Click Add Secret Key',
            description: 'Use the button below to link the channel and generate the secret key.',
        }
    ];


    const accordionSections = [
        {
            id: 'chat',
            title: 'Telegram Chat ID',
            icon: FaTelegramPlane,
            description: 'Connect your personal chat for direct alerts',
            buttonText: 'Add New Chat ID',
            action: generatetelegramlink,
            columns: ["Telegram_ID", "Notifications"]
        },
        // {
        //     id: 'group',
        //     title: 'Telegram Group ID',
        //     icon: FaUsers,
        //     description: 'Add your trading group for team alerts',
        //     buttonText: 'Add Secret Key',
        //     action: () => openModal('group'),
        //     columns: ['Group_ID', 'Group_Name']
        // },
        // {
        //     id: 'channel',
        //     title: 'Telegram Channel ID',
        //     icon: FaBroadcastTower,
        //     description: 'Connect your broadcast channel',
        //     buttonText: 'Add Secret Key',
        //     action: () => openModal('channel'),
        //     columns: ['Channel_ID', 'Channel_Name']
        // }
    ];

    return (
        <div className="m-2 ">
            <div className=" rounded-xl overflow-hidden hover-scale">
                {/* <div className="bg-logiculustheme-neonBlue p-4">
                    <div className="flex items-center space-x-3">
                        <div className="p-3 bg-white bg-opacity-20 rounded-full">
                            <FaGlobe className="w-5 h-5 text-white" />
                        </div>
                        <h2 className="text-2xl font-bold text-foreground">Connection Links</h2>
                    </div>
                </div> */}

                {/* Links Section */}


                <div className="grid gap-6">
                    {accordionSections.map((section) => (
                        <div key={section.id} className="   shadow-card overflow-hidden">
                            <div
                                className="flex justify-between items-center cursor-pointer hover:bg-muted/30 transition-all duration-300"
                                onClick={() => toggleAccordion(section.id)}
                            >
                                <div className="flex items-center gap-4">
                                    <div className={`p-3 rounded-xl transition-all duration-300 ${activeAccordion === section.id
                                        ? 'bg-gradient-button text-white shadow-glow'
                                        : 'bg-muted text-muted-foreground'
                                        }`}>
                                        <section.icon className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-foreground">{section.title}</h3>
                                        <p className="text-sm text-muted-foreground">{section.description}</p>
                                    </div>
                                </div>
                                <div className={`p-2 rounded-full transition-all duration-300 ${activeAccordion === section.id
                                    ? 'bg-primary/20 text-primary'
                                    : 'text-muted-foreground'
                                    }`}>
                                    {activeAccordion === section.id ? <FaChevronUp /> : <FaChevronDown />}

                                </div>
                            </div>

                            {activeAccordion === section.id && (
                                <div className="px-6 pb-6 space-y-6 animate-in slide-in-from-top-2 duration-200">

                                    {/* Render steps for group */}
                                    {section.id === 'group' && (
                                        <div className="space-y-3">
                                            {groupSteps.map((s) => (
                                                <StepBox key={s.step} {...s} />
                                            ))}
                                        </div>
                                    )}
                                    {section.id === 'channel' && (
                                        <div className="space-y-3">
                                            {channelSteps.map((s) => (
                                                <StepBox key={s.step} {...s} />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}


                            {activeAccordion === section.id && (
                                <div className="px-6 pb-6 space-y-4 animate-in slide-in-from-top-2 duration-200">
                                    {!(userdetails[0]?.Telegram_ID && section.id === 'chat') && (
                                        <button
                                            onClick={section.action}
                                            className="flex items-center gap-2 bg-primary text-black px-6 py-3 rounded-xl font-medium transition-all duration-200 hover:scale-105 transform shadow-glow"
                                        >
                                            <FaPlus className="w-4 h-4" />
                                            {section.buttonText}
                                        </button>
                                    )}


                                    {userdetails.length > 0 && userdetails[0]?.Telegram_ID !== "" && (
                                        <Table
                                            data={userdetails}
                                            columns={section.columns}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>


                {/* Modal */}
                {isModalOpen && (
                    <Modal
                        modalType={modalType}
                        secretKey={secretKey}
                        setSecretKey={setSecretKey}
                        onClose={() => setIsModalOpen(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default TelegramAlerts;